import React from 'react';

import CalculatorCore, {Props} from './CalculatorCore';
import SubjectWithLetterScore from './SubjectWithLetterScore';
import {LetterGrade} from '../constants';
import SubjectBasic from './SubjectBasic';

const LETTER_OPTIONS: ReadonlyArray<LetterGrade> = [
  LetterGrade.A,
  LetterGrade.B,
  LetterGrade.C,
  LetterGrade.D,
  LetterGrade.E,
];

export default function CalculatorQCE(props: Props) {
  return (
    <CalculatorCore
      {...props}
      subjectRenderer={subject => {
        const isAppliedSubject = subject.subjectType === 'applied';
        const commonProps = {
          key: subject.ID_SUBJECT,
          subject: subject,
          onDeleteSubject: props.onDeleteSubject,
          onUpdateSubject: props.onUpdateSubject,
        };
        return isAppliedSubject ? (
          <SubjectWithLetterScore
            {...commonProps}
            letterOptions={LETTER_OPTIONS}
          />
        ) : (
          <SubjectBasic {...commonProps} />
        );
      }}
    />
  );
}
